import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { getStackSideOptions } from '../../../helpers/stackSide';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  stackSide: string,
  honeycombVerticalCentreOpeningSurcharge: number,
  honeycombVerticalCentreOpeningSurchargePrice: number,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (
  stackSide,
  honeycombVerticalCentreOpeningSurcharge,
  honeycombVerticalCentreOpeningSurchargePrice,
  send,
) => () => {
  let custom = {
    stackSide: stackSide,
    honeycombVerticalCentreOpeningSurchargePrice: 0,
    honeycombVerticalCentreOpeningSurcharge: 0,
  };
  if (stackSide === 'Centre Opening') {
    custom.honeycombVerticalCentreOpeningSurcharge = honeycombVerticalCentreOpeningSurcharge;
    custom.honeycombVerticalCentreOpeningSurchargePrice = honeycombVerticalCentreOpeningSurchargePrice;
  }
  send({
    type: 'UPDATE_CUSTOM',
    custom,
  });
};

export const StackSide = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    honeycombVerticalCentreOpeningSurcharge,
    custom: { stackSide },
  } = state.context;
  const stackSideOptions = getStackSideOptions(state.context);
  const productType = getBaseProductType(state.context);

  if (isCurrentState('stackSide', state) && stackSideOptions.length === 0) {
    throwError(state);
  }

  const honeycombVerticalCentreOpeningSurchargeId =
    honeycombVerticalCentreOpeningSurcharge[0].first_available_variant.id;
  const honeycombVerticalCentreOpeningSurchargePrice =
    honeycombVerticalCentreOpeningSurcharge[0].first_available_variant.price;

  return (
    <SectionContent>
      <Heading>Stack side</Heading>
      <Selector>
        {stackSideOptions.map(option => {
          const { description } = getProductStateConfig(
            productType,
            'stackSide',
            option,
          );
          return (
            <SelectorItem
              isSelected={option === stackSide}
              onClick={onClick(
                option,
                honeycombVerticalCentreOpeningSurchargeId,
                honeycombVerticalCentreOpeningSurchargePrice,
                send,
              )}
              key={option}
            >
              {option}
              {description && <Caption>{description}</Caption>}
            </SelectorItem>
          );
        })}
      </Selector>
    </SectionContent>
  );
};
